<template>
	<div class="">
		<headerTop value="2"></headerTop>
		<div class="shenbaoA flex justify-between align-start">
			<div class="" style="width: 1144px;min-height: 600px;">
				<!-- <div class="bg-white" style="width: 1144px;padding: 20px 50px;border-radius: 10px;margin-bottom: 20px;">
					<div class="flex justify-center align-center">
						<el-input style="margin-right: 8px;" size="medium" v-model="keyword" placeholder="请输入内容">
						</el-input>
						<el-button
							style="background: #015897;border-color: #015897;border-radius: 18px;width: 180px;margin-left: 20px;"
							@click="tosearch" size="medium" type="primary">搜索</el-button>
					</div>
				</div> -->
				<div class="bg-white" style="width: 1144px;padding: 120px 100px 20px;border-radius: 10px;">
					<div class="sd_title">
						<p class="biaoti1">{{ detail.title }}</p>
						<p class="bt_mes">
							<span v-if="detail.create_time">发布时间：{{ detail.create_time }}</span>
							<span v-if="detail.created_at">发布时间：{{ detail.created_at }}</span>
							<span v-if="detail.form">来源：{{ detail.form }}</span>
						</p>
					</div>
					<div v-if="type == 3" class="sd_content">
						<div v-if="detail.territory" class="cardView">
							<div class="tagtext">支持领域</div>
							<div class="" v-html="detail.territory"></div>
						</div>
						<div v-if="detail.according" class="cardView">
							<div class="tagtext">依据文件</div>
							<div class="" v-html="detail.according"></div>
						</div>
						<div v-if="detail.content" class="cardView">
							<div class="tagtext">最新动态</div>
							<div class="" v-html="detail.content"></div>
						</div>
						<div v-if="detail.declare_condition" class="cardView">
							<div class="tagtext">申报条件</div>
							<div class="" v-html="detail.declare_condition"></div>
						</div>
						<div v-if="detail.effort" class="cardView">
							<div class="tagtext">支持力度</div>
							<!-- <div class="" v-html="detail.effort"></div> -->
							<div class="text-center">
								<!-- height="250"  -->
								<el-table :data="detail.level" border style="width: 100%">
									<el-table-column prop="index" align="center" width="100px" label="序号">
									</el-table-column>
									<el-table-column prop="level" align="center" width="100px" label="支持等级">
									</el-table-column>
									<el-table-column prop="factor" align="center" width="180px" label="资助条件">
									</el-table-column>
									<el-table-column prop="money" align="center" label="资助金额"></el-table-column>
									<el-table-column label="参考文件" align="center">
										<template slot-scope="scope">
											<div class="cpoint" style="color: #0081ff;" @click="toout(scope.row.href)"
												:data-url="scope.row.href">{{scope.row.file}}</div>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
					</div>
					<div v-else class="sd_content padding-top">
						<div class="" v-html="detail.content"></div>
					</div>
				</div>
			</div>
			<!-- <div class="cright" style="width: 193px; height: 100%">
				<company-card type="2" :id="id" ></company-card>

				<div class="">
					<div class="bg-white" style="border-radius: 10px;" v-if="common.rightSidebar">
						<div class="box1_header" style="border-bottom: none;">
							<div class="box1_header_shu"></div>
							<div class="box1_header_text">服务推荐</div>
						</div>
						<div class="">
							<div class="likeone1" v-for="(item, index) in advertiselist" :key="index"
								@click="tonext(item.href)">
								<div class="oneleft1">
									<img :src="item.pic | addurl" alt="">
								</div>
								<div class="oneright1">
									<div class="text-cut text-center" style="font-size: 18px;width: 100%;">
										{{item.title}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div> -->
		</div>
		<div class="" style="width: 100%;height: 40px;"></div>
		<!-- <div class="flex justify-start align-center flex-wrap" style="width: 90%;margin: 20px auto;">
        <div class="flex justify-between align-center advone" v-for="(item,index) in advertiselist" :key="index" @click="tonext(item.url)">
            <div class="" style="width: 65px;">
              <img style="width: 65px;height: 65px;border-radius: 50%;" :src="item.pic | addurl" alt="">
            </div>
            <div class="flex justify-center align-start flex-direction" style="width: 225px;">
              <div class="text-cut" style="font-weight: 700;font-size: 24px;color: #111;width: 100%;">{{item.title}}</div>
              <div class="text-cut" style="margin-top: 5px;font-size: 17px;color: #999999;width: 100%;">{{item.detail}}</div>
            </div>
        </div>
    </div> -->
		<!-- <footers></footers> -->
	</div>
</template>
<script>
	import headerTop from "../../components/headerTop.vue";
	// import footers from "../../components/foot/footer.vue";
	import companyCard from "@/components/recommend"
	export default {
		components: {
			headerTop: headerTop,
			"company-card": companyCard
		},
		data() {
			return {
				query: "",
				navtype: 0,
				type: "",
				id: "",
				detail: "",
				likelist: [],
				advertiselist: [],
				keyword: '',
				tableData: [{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-01',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-08',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-06',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-07',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}],
				common: ''
			};
		},
		methods: {
			toout(url) {
				window.open(url, '_blank')
			},
			tosearch() {
				if (!this.keyword) {
					this.$message({
						message: '请输入搜索内容',
						type: 'warning'
					});
					return false;
				}
			},
			getdetail() {
				const loading = this.$loading({
					lock: true,
					text: '加载中……',
					spinner: 'el-icon-loading',
					background: 'rgba(255, 255, 255, 0)'
				});
				this.$api.user.noticedetail({
					id: this.id,
				}).then(res => {
					if (res.code == 1) {
						for (let i in res.data.level) {
							res.data.level[i]['index'] = Number(i) + 1;
						}
						this.detail = res.data;
						loading.close();
					} else {
						loading.close();
					}
				})
			},
			tonext(url) {
				window.open(url);
			},
			// getadv() {//20241225政策宝通知该接口失效
			// 	this.$api.user.get_advertise(res => {
			// 		if (res.code == 1) {
			// 			this.advertiselist = res.data;
			// 		}
			// 	})
			// }
		},
		created() {
			this.type = this.$route.query.type;
			this.id = this.$route.query.id;
			this.getdetail();
		},
	};
</script>
<style scoped>
	.sd_content {
		font-size: 22px;
		line-height: 36px;
		color: #737373;
		min-height: 200px;
	}

	.cardView {
		border: solid #0070c0 1px;
		border-radius: 10px;
		position: relative;
		padding: 20px;
		margin-bottom: 25px;
	}

	.cardView .tagtext {
		position: absolute;
		background-color: #0070c0;
		padding: 0px 10px;
		border-radius: 15px;
		line-height: 26px;
		color: #ffe;
		top: -15px;
		font-size: 12px;
	}

	.shenbaoA {
		width: 1200px;
		height: auto;
		margin: 0 auto;
		margin-top: 20px;
	}

	.sd_title {
		text-align: center;
		border-bottom: 1px solid #eee;
	}

	.biaoti1 {
		font-size: 22px;
		color: #202020;
		line-height: 42px;
	}

	.bt_mes {
		font-size: 15px;
		color: #7f7f7f;
		line-height: 35px;
		margin-bottom: 20px;
	}

	.sd_content {
		font-size: 22px;
		line-height: 36px;
		color: #737373;
		min-height: 200px;
	}

	input:focus,
	textarea:focus {
		outline: none;
	}

	.sub_btn {
		width: 185px;
		height: 52px;
		background-color: #0070c0;
		border-radius: 6px;
		border: none;
		font-size: 22px;
		color: #fff;
		margin-top: 25px;
	}

	.sd_sub {
		padding-bottom: 30px;
		border-bottom: 2px solid #eee;
		text-align: center;
	}

	.next_all {
		margin-bottom: 30px;
		padding-left: 20px;
	}

	.next_all .previous,
	.next_all ._next {
		color: #7f7f7f;
		line-height: 32px;
	}

	img {
		max-width: 100%;
	}

	.samecom {
		height: 50px;
		line-height: 50px;
		width: 100%;
		color: #292a2d;
		font-size: 18px;
		font-weight: 700;
		border-bottom: 1px solid #eff2f6;
		text-align: center;
	}

	.likeone {
		height: auto;
		padding: 12px 16px;
		border-bottom: 1px solid #eff2f6;
		cursor: pointer;
		display: flex;
		justify-content: flex-start;
		/* align-content: center; */
		align-items: flex-start;
	}

	.likeone:hover {
		/* background: #f6f7fb;
  box-shadow: 0 6px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 2px;
  z-index: 9;
  position: relative; */
	}

	.oneleft {
		width: 44px;
		height: 44px;
	}

	.oneleft img {
		width: 44px;
		max-height: 44px;
	}

	.oneright {
		padding-left: 10px;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		flex-direction: column;
	}

	.oneright p {
		font-size: 16px;
		color: #111111;
		/* font-weight: 550; */
		padding-bottom: 2px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100%;
	}

	.oneright span {
		display: inline-block;
		padding: 2px 8px;
		font-size: 12px;
		color: #fff;
		font-weight: 400;
		background: #36a6f7;
		border-radius: 2px;
	}

	.advone {

		width: 300px;
		height: 120px;
		background-color: #ffffff;
		border-radius: 40px;
		margin-right: 15px;
		padding: 0 20px;
		margin-bottom: 20px;
	}

	.advone img {
		display: block;
	}

	.box1_header {
		display: flex;
		height: 55px;
		padding: 0 15px;
		align-items: center;
		border-bottom: 1px solid #eee;
	}

	.box1_header_text {
		font-size: 20px;
		color: #111111;
		font-weight: 600;
		margin-left: 10px;
	}

	.box1_header_shu {
		width: 4px;
		height: 21px;
		background-color: #0070c0;
	}

	.likeone1 {
		height: auto;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		margin-bottom: 25px;
	}

	.likeone1:hover {
		/* background: #f6f7fb;
  box-shadow: 0 6px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 2px;
  z-index: 9;
  position: relative; */
	}

	.likeone1:last-child {
		margin-bottom: 0px;
	}

	.oneleft1 {
		width: 99px;
		height: 99px;
	}

	.oneleft1 img {
		width: 99px;
		height: 99px;
		border-radius: 10px;
	}

	.oneright1 {
		margin-top: 10px;
		width: 77%;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		flex-direction: column;
	}

	.oneright1 p {
		font-size: 14px;
		color: #292a2d;
		font-weight: 400;
		padding-bottom: 2px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 214px;
	}

	.oneright1 span {
		display: inline-block;
		padding: 2px 8px;
		font-size: 12px;
		color: #fff;
		font-weight: 400;
		background: #36a6f7;
		border-radius: 2px;
	}

	.cright {
		position: sticky;
		/* top: 166px; */
		top: 20px;
	}
</style>


// WEBPACK FOOTER //
// detail.vue?9ad71310